import React from "react";
import Loader from "react-loader-spinner";

import { makeStyles } from "@material-ui/core";
import { lightTheme } from "../../../App.theme";

const useStyles = makeStyles(theme => ({
  root: {
    width: "100%",
    display: "flex",
    justifyContent: "center",
    alignItems: "center"
  }
}));

const LoaderComponent = ({ size }) => {
  const { root } = useStyles();
  return (
    <div className={root}>
      <Loader
        type="Puff"
        color={lightTheme.palette.primary.main}
        height={size || 100}
        width={size || 100}
      />
    </div>
  );
};

export default LoaderComponent;
